import * as React from 'react';
import { styled } from '@mui/material/styles';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import { PickersDay, PickersDayProps } from '@mui/x-date-pickers/PickersDay';
import moment, { Moment } from "moment";

interface CustomPickerDayProps extends PickersDayProps {
    isSelected: boolean;
    isHovered: boolean;
}

const CustomPickersDay = styled(PickersDay, {
    shouldForwardProp: (prop) => prop !== 'isSelected' && prop !== 'isHovered',
})<CustomPickerDayProps>(({ theme, isSelected, isHovered, day }) => ({
    borderRadius: 0,
    ...(isSelected && {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        '&:hover, &:focus': {
            backgroundColor: theme.palette.primary.main,
        },
    }),
    ...(isHovered && {
        backgroundColor: theme.palette.primary[theme.palette.mode],
        '&:hover, &:focus': {
            backgroundColor: theme.palette.primary[theme.palette.mode],
        },
    }),
    ...(day.day() === 6 && { //Saterday
        borderTopLeftRadius: '50%',
        borderBottomLeftRadius: '50%',
    }),
    ...(day.day() === 5 && { //Friday
        borderTopRightRadius: '50%',
        borderBottomRightRadius: '50%',
    }),
})) as React.ComponentType<CustomPickerDayProps>;

const isInSameWeek = (dayA: moment.Moment, dayB: moment.Moment | null | undefined) => {
    if (!dayB) return false;
    let startA = isCustomWeekend(dayA.clone());
    let startB = isCustomWeekend(dayB.clone());

    return startA.isoWeek() === startB.isoWeek() && startA.isoWeekYear() === startB.isoWeekYear();
};

//if value is a weekend, move it to the resq moday
const isCustomWeekend = (day: moment.Moment) => {
    if (day.day() === 0) //Sunday
        day.add(1, 'day');
    else if (day.day() === 6) //Saterday
        day.add(2, 'day');

    return day;
}

function Day(
    props: PickersDayProps & {
        selectedDay?: Moment | null;
        hoveredDay?: Moment | null;
    },
) {
    const { day, selectedDay, hoveredDay, ...other } = props;

    return (
        <CustomPickersDay
            {...other}
            day={day}
            sx={{ px: 2.5 }}
            disableMargin
            selected={false}
            isSelected={isInSameWeek(day, selectedDay)}
            isHovered={isInSameWeek(day, hoveredDay)}
        />
    );
}

interface IWeekPickerProps {
    startOfWeek: Moment | null
    onDateChange: (newValue: Moment) => void
}

export default function ResqWeekPicker({ startOfWeek, onDateChange }: IWeekPickerProps) {
    const [hoveredDay, setHoveredDay] = React.useState<Moment | null>(null);

    return (
        <DateCalendar
            value={startOfWeek}
            onChange={(newValue: moment.Moment) => onDateChange(isCustomWeekend(newValue))}
            showDaysOutsideCurrentMonth
            displayWeekNumber
            disableFuture
            slots={{ day: Day }}
            slotProps={{
                day: (ownerState) =>
                ({
                    selectedDay: startOfWeek,
                    hoveredDay,
                    onPointerEnter: () => setHoveredDay(ownerState.day),
                    onPointerLeave: () => setHoveredDay(null),
                } as any),
            }}
        />
    );
}